import { render, staticRenderFns } from "./SalesSubcategory.vue?vue&type=template&id=682a7ce4&scoped=true&"
import script from "./SalesSubcategory.vue?vue&type=script&lang=js&"
export * from "./SalesSubcategory.vue?vue&type=script&lang=js&"
import style0 from "./SalesSubcategory.vue?vue&type=style&index=0&id=682a7ce4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682a7ce4",
  null
  
)

export default component.exports